import { notification } from 'antd'
import axios from 'axios'

const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  signIn: '/auth/signin',
  signUp: '/auth/signup',
  updateProfile: '/user/updateProfile',
}

const config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
}

export async function login(email, password) {
  console.log('apiRoor:', apiRoot)
  const credentilas = { loginname: email, password }
  const url = fsConfig.root + fsConfig.signIn
  return axios
    .post(url, qs.stringify(credentilas), config)
    .then(response => {
      return response.data
    })
    .catch(error => {
      notification.warning({
        message: error.response.data.error,
        description: error.response.data.message || error.message,
      })
    })
}

export async function updateProfile(data, token) {
  const url = fsConfig.root + fsConfig.updateProfile
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .post(url, qs.stringify(data), newConfig)
    .then(response => {
      return response.data
    })
    .catch(error => {
      notification.warning({
        message: error.code,
        description: error.response.data.message || error.message,
      })
    })
}

export async function register(email, password, invitation, subscript) {
  const registerDto = { loginname: email, password, invitation, subscript }
  const url = fsConfig.root + fsConfig.signUp
  console.log('credentials:', registerDto)
  return axios
    .post(url, qs.stringify(registerDto), config)
    .then(response => {
      console.log('created user:', response.data)
      return true
    })
    .catch(error => {
      // console.log('Error: ', JSON.stringify(error.response));
      if (error.response.data.statusCode === 409 || error.response.data.statusCode === 404) {
        const message = 'Usuario no creado'
        const description = error.response.data.message
        notification.warning({
          message,
          description,
        })
      } else {
        const reasons = error.response.data.message
        reasons.forEach(element => {
          const message = element.property
          const description = `${element.constraints.matches}. ${element.constraints.minLength}`
          notification.warning({
            message,
            description,
          })
        })
      }
      return null
    })
}

/* export async function currentAccount(user){
    return new Promise((resolve, reject)=> {
      try {
        console.log('user: ', user )
          resolve( user )
      } catch(error) {
        reject(error)
      }
    })
} */

export async function logout() {
  console.log('logout')
  return true
}
